import { OptionValues } from './types/composition';
import { PropertyDefaultCase } from './types/catalog-types';
import { Material } from './types/catalog-internal';

export function calculateImplicitValues(
    defaults: Record<string, string|null|PropertyDefaultCase[]>,
    values: OptionValues,
    qualities: Material[] = []
) {
    const tmpImplicit: Record<string,string|null|PropertyDefaultCase[]> = {};
    for(const [key, value] of Object.entries(defaults)) {
        if(value && typeof value === 'string') {
            tmpImplicit[key] = value;
        }
    }
    for(const [key, value] of Object.entries(values)) {
        if(value) {
            tmpImplicit[key] = value;
        }
    }

    let changed = false;
    do {
        changed = false;
        for(const [key, value] of Object.entries(tmpImplicit)) {
            if(value && typeof value === 'string' && value.startsWith('*PROPERTY:')) {
                const prop = value.substring('*PROPERTY:'.length);
                if(tmpImplicit[prop]) {
                    tmpImplicit[key] = tmpImplicit[prop];
                    changed = true;
                }
            }
        }

        for(const [key, defaultValue] of Object.entries(defaults)) {
            if(!defaultValue || !Array.isArray(defaultValue)) {
                continue;
            }

            // qualityHasTag cases may override an explicit/initial value (e.g. fabric → extraseams 0).
            let tagMatched = false;
            for(const vcase of defaultValue) {
                if(!('qualityHasTag' in vcase) || !('property' in vcase)) {
                    continue;
                }
                const testValue = tmpImplicit[vcase.property];
                if(typeof testValue !== 'string' || testValue.startsWith('*PROPERTY:')) {
                    continue;
                }
                const [qualityCode] = testValue.split('/');
                const quality = qualities.find(m => m.code === qualityCode);
                if(quality?.tags.includes(vcase.qualityHasTag)) {
                    if(tmpImplicit[key] !== vcase.set) {
                        tmpImplicit[key] = vcase.set;
                        changed = true;
                    }
                    tagMatched = true;
                    break;
                }
            }
            if(tagMatched) {
                continue;
            }

            // oneOf / bare set: only when the property is not explicitly set (legacy behaviour).
            if(values[key] != null) {
                continue;
            }

            for(const vcase of defaultValue) {
                if('qualityHasTag' in vcase) {
                    continue;
                }
                if('property' in vcase && 'oneOf' in vcase) {
                    const testValue = tmpImplicit[vcase.property];
                    if(testValue && (!Array.isArray(testValue) && !testValue?.startsWith('*PROPERTY:'))) {
                        if(vcase.oneOf.includes(testValue)) {
                            if(tmpImplicit[key] !== vcase.set) {
                                tmpImplicit[key] = vcase.set;
                                changed = true;
                            }
                            break;
                        }
                    }
                } else if('set' in vcase) {
                    if(tmpImplicit[key] !== vcase.set) {
                        tmpImplicit[key] = vcase.set;
                        changed = true;
                    }
                    break;
                }
            }
        }
    } while(changed);

    const implicit: OptionValues = {};
    for(const [key, value] of Object.entries(tmpImplicit)) {
        if(value && typeof value === 'string') {
            implicit[key] = value;
        }
    }
    return implicit;
}
